module.exports = __webpack_public_path__ + "img/hairsalon5.26547da8.png";